import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IAdminBooking, ICancelBookingRequest } from '../../../../assets/types/dtoTypes';

@Component({
  selector: 'app-cancel-booking-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './cancel-booking-modal.component.html',
  styleUrls: ['./cancel-booking-modal.component.scss'],
})
export class CancelBookingModalComponent {
  private dialogRef = inject(MatDialogRef<CancelBookingModalComponent>);
  data = inject<{ booking: IAdminBooking }>(MAT_DIALOG_DATA);

  reason = '';

  get isValid(): boolean {
    return this.reason.trim().length > 0;
  }

  close(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (!this.isValid) return;
    const result: ICancelBookingRequest = { reason: this.reason.trim() };
    this.dialogRef.close(result);
  }
}
